'use client'

/* eslint-disable @typescript-eslint/no-misused-promises */

import React from 'react'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { homePageCommonProps } from '@utils/segmentProperties'
import styles from './banner.module.scss'

interface BannerProps {
  desktopText: string
  mobileText: string
  mobileIcon?: string
  desktopIcon?: string
  ctaLabelDesktop: string
  ctaLabelMobile: string
  ctaText: string
  redirectUrl: string
}

const Banner: React.FC<BannerProps> = ({
  desktopText,
  mobileText,
  mobileIcon,
  desktopIcon,
  ctaLabelDesktop,
  ctaLabelMobile,
  ctaText,
  redirectUrl,
}) => {
  const onClickHandler = async () => {
    const commonProps = homePageCommonProps()
    await trackEvent('tap_btn_airpass', {
      ...commonProps,
      type: 'banner strip',
      from_page: window?.location?.href,
      cta_text: ctaText,
    })
    if (redirectUrl && window?.location?.href) {
      window.location.href = redirectUrl
    }
  }

  return (
    <div className={styles.bannerContainer}>
      <div className={styles.bannerText}>
        <div className={styles.bannerIcon}>
          {mobileIcon && <img src={mobileIcon} alt="Mobile Icon" className={styles.showMobile} />}
          {desktopIcon && <img src={desktopIcon} alt="Desktop Icon" className={styles.showDesktop} />}
        </div>
        <div
          className={styles.showDesktop}
          dangerouslySetInnerHTML={{
            __html: desktopText,
          }}
        />
        <div
          className={styles.showMobile}
          dangerouslySetInnerHTML={{
            __html: mobileText,
          }}
        />
      </div>
      <div className={styles.bannerCta} onClick={onClickHandler}>
        <div className={styles.ctaLabel}>
          {ctaLabelMobile && <div className={styles.showMobile}>{ctaLabelMobile}</div>}
          {ctaLabelDesktop && <div className={styles.showDesktop}>{ctaLabelDesktop}</div>}
        </div>
        <div className={styles.ctaText}>{ctaText}</div>
      </div>
    </div>
  )
}

export default Banner
